<template>
  <div>
    <div class="info">
      <div style="margin-top: 6px">
        <icon-info-warning></icon-info-warning>
      </div>
      <div style="margin-left: 10px">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.info {
  background: #e6f1ff;
  border-radius: 5px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: #1c1363;
  margin-bottom: 30px;
  padding: 20px 10px 20px 10px;
  display: flex;
  align-items: center;
  justify-content: left;
}
</style>